export const obscureCPF = (cpf: string) =>
  cpf.substring(0, 3) +
  cpf.substring(3, cpf.length - 2).replaceAll(/\d/g, '*') +
  cpf.substring(cpf.length - 2);
